package com.anjuros.website.templates.template2.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template2.components.Template2SectionTitle
import com.anjuros.website.templates.template2.modules.Template2Achievement
import com.anjuros.website.templates.template2.modules.Template2Reason
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.Template2AchievementsStyle
import com.anjuros.website.templates.template2.styles.Template2ReasonCardStyle
import com.anjuros.website.templates.template2.styles.Template2ReasonColumnStyle
import com.anjuros.website.templates.template2.util.ResKey
import com.anjuros.website.templates.template2.util.Template2ObserverViewportEntered
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flex
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template2AchievementsSection(){

    Box(modifier = Modifier
        .fillMaxWidth()
        .backgroundColor(Template2Theme.Background.rgb)
        .id("Achievement")
        .padding(topBottom = 20.px),
        contentAlignment = Alignment.Center) {

        Template2WhyChooseSection()
    }
}

@Composable
fun Template2WhyChooseSection() {

    val breakpoint = rememberBreakpoint()

    val animatedOpacity = remember { mutableStateOf(0.0f) }

    Template2ObserverViewportEntered(
        sectionId = "achievement",
        distanceFromTop = 100.0
    ) {
        animatedOpacity.value = 1.0f
    }
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .id("achievement")
            // Side space as padding (inside the width), so the section never runs wider than the screen.
            .padding(top = 120.px, bottom = 150.px, leftRight = 24.px)
            .maxWidth(1380.px)
            .gap(80.px)
            // Photo and reasons side by side only on large screens; stacked on tablets and phones.
            .flexDirection(
                if (breakpoint >= Breakpoint.LG)
                    FlexDirection.Row
                else
                    FlexDirection.Column
            )
            .alignItems(AlignItems.Center)
    ) {

        //====================================================
        // LEFT
        //====================================================

        Box(
            modifier = Modifier
                .flex(1)
                .position(Position.Relative)
        ) {


            // Main image

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(
                        if (breakpoint >= Breakpoint.MD)
                            640.px
                        else
                            460.px
                    )
                    .boxShadow(
                        offsetY = 6.px,
                        blurRadius = 10.px,
                        color = rgba(0,0,0,.4)
                    )
                    .overflow(Overflow.Hidden)
                    .position(Position.Relative)
            ) {

                AnjurosImage(
                    modifier = Modifier
                        .fillMaxSize()

                        .objectFit(ObjectFit.Cover),
                    src = "template2_about2.png",
                    alt = "Professional handyman"
                )

            }

            Template2AchievementStrip(
                modifier = Modifier.align(Alignment.BottomCenter).zIndex(2),
                opacity = animatedOpacity.value
            )

        }

        //====================================================
        // RIGHT
        //====================================================

        Column(
            modifier = Template2ReasonColumnStyle.toModifier()
        ) {


            Template2SectionTitle(
                modifier = Modifier.fillMaxWidth(),
                title = ResKey.TEMPLATE2_WHY_CHOOSE_TITLE,
                text = ResKey.TEMPLATE2_WHY_CHOOSE_DESCRIPTION,
                textAlign = if(breakpoint>=Breakpoint.LG) TextAlign.Start else TextAlign.Center
            )


            SimpleGrid(
                numColumns = numColumns(base = 1, md=2),
                modifier = Modifier .fillMaxWidth()
            ){
                Template2Reason.entries.forEach { reason->
                    Box(modifier = Modifier

                        .margin(10.px),
                        contentAlignment = Alignment.Center) {
                        Template2ReasonCard(
                            reason = reason
                        )
                    }

                }
            }
        }

    }

}

@Composable
fun Template2ReasonCard(
    reason: Template2Reason
) {

    Box(
        modifier = Template2ReasonCardStyle.toModifier()
            .fillMaxSize()

    ) {

        Row(
            modifier = Modifier
                .align(Alignment.Center)
                .fillMaxWidth()
                .padding(22.px)
                .gap(18.px)
                .alignItems(AlignItems.Center)
        ) {

            //====================================================
            // ICON
            //====================================================

            Box(
                modifier = Modifier
                    .size(56.px)
                    .borderRadius(50.percent)
                    .backgroundColor(rgb(250, 245, 238))
                    .display(DisplayStyle.Flex)
                    .justifyContent(JustifyContent.Center)
                    .alignItems(AlignItems.Center)
                    .flexShrink(0)
            ) {

                AnjurosIcon(
                    modifier = Modifier
                        .size(40.px)
                       ,
                    src = reason.icon,
                    alt = ""
                )

            }

            //====================================================
            // TEXT
            //====================================================

            Column {

                P(
                    attrs = Modifier
                        .fontSize(22.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Template2Theme.Primary.getColor())
                        .margin(bottom = 8.px)
                        .toAttrs()
                ) {
                    Text(LocalText(reason.title))
                }

                P(
                    attrs = Modifier
                        .fontSize(16.px)
                        .lineHeight(1.7)
                        .color(rgb(95,95,95))
                        .margin(0.px)
                        .toAttrs()
                ) {
                    Text(LocalText(reason.description))
                }

            }

        }

    }

}
@Composable
fun Template2AchievementStrip(
    modifier: Modifier,
    opacity: Float
) {
    // Smaller on phones, so the strip covers less of the photo.
    val compact = rememberBreakpoint() < Breakpoint.MD


    Box(
        modifier = modifier
            .fillMaxWidth(90.percent)
            .margin(bottom = 20.px)
           // .backgroundColor(rgba(255, 255, 255, .92))
            .backgroundImage(
                linearGradient(
                    rgba(255, 255, 255, .5),
                    rgba(255, 255, 255, .9),
                    LinearGradient.Direction.ToBottom
                )
            )
            .borderRadius(22.px)
            .boxShadow(
                offsetY = 20.px,
                blurRadius = 45.px,
                color = rgba(0, 0, 0, .3)
            )
            .padding(
                leftRight = if (compact) 12.px else 28.px,
                topBottom = if (compact) 12.px else 24.px
            )
    ) {

        // Two pairs of stats: side by side (four in a row) when the strip is wide enough, otherwise one pair
        // above the other (two by two). Never three and one. Each pair's flex-basis is huge below 420px of
        // strip width and zero above it, which flips the pairs between stacked and side by side.
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .styleModifier { property("flex-wrap", "wrap"); property("row-gap", "8px") }
        ) {

            Template2Achievement.entries.withIndex().chunked(2).forEach { pair ->
                Row(
                    modifier = Modifier.styleModifier {
                        property("flex-grow", "1")
                        property("flex-basis", "calc((420px - 100%) * 999)")
                    }
                ) {
            pair.forEach { (index, achievement) ->

                Box(
                    modifier = Modifier
                        .flex(1)
                        .styleModifier { property("min-width", "0") }
                        .height(if (compact) 64.px else 95.px)
                ) {


                    Column(
                        modifier = Modifier
                            .fillMaxSize(),
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {

                        P(
                            attrs = Template2AchievementsStyle.toModifier()
                                .fontWeight(FontWeight.Bold)
                                .opacity(opacity)
                                .transition(Transition.of("opacity",700.ms, delay = index*600.ms))
                                .color(Theme.Secondary.rgb)
                                .margin(bottom = 4.px)
                                .toAttrs()
                        ) {
                            Text(LocalText(achievement.number))
                        }

                        P(
                            attrs = Modifier
                                .fontSize(14.px)
                                .color(Template2Theme.Primary.rgb)
                                .margin(0.px)
                                .textAlign(TextAlign.Center)
                                .toAttrs()
                        ) {
                            Text(LocalText(achievement.text))
                        }

                    }

                }

            }
                }
            }

        }

    }

}
